// extracted by mini-css-extract-plugin
export var iconContainer = "_fd-0";
export var metricCardsContainer = "_fd-1";